import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import Modal from 'components/Modal';
import AdminLayout from 'layouts/AdminLayout';
import PluginService from 'services/pluginService';

export default function PluginPage() {
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleFileUpload = async () => {
    //   if (!selectedFile) return toast.warning('Please select a file to upload!');
    //   const formData = new FormData();
    //   formData.append('plugin', selectedFile);
    //   try {
    //     const response = await PluginService.uploadPlugin(formData);
    //     toast.success(response.data.message);
    //     const plugins = await pluginsLoader();
    //     setTimeout(() => {
    //       setUploadedFiles(plugins.data.plugins);
    //       setModalOpen(!modalOpen);
    //     }, 1000);
    //   } catch (error) {
    //     toast.error(error.response.data.message);
    //   }
  };

  const handlePluginExecution = async (pluginName) => {
    PluginService.executePlugin(pluginName).then((response) => {
      if (response.status === 'Success') {
        toast.success(response.message);
      }
    });
  };

  const handleDownload = async () => {
    window.location.href = process.env.REACT_APP_CDN_URL + '/files/examples/144f9d0b4729160d-plugins.zip';
  };

  // function handleModal() {
  //   setModalOpen(!modalOpen);
  // }

  useEffect(() => {
    PluginService.getPlugins().then((data) => {
      setUploadedFiles(data);
    });
  }, []);

  return (
    <AdminLayout>
      <Modal isOpen={modalOpen}>
        <div className="p-4 flex flex-col items-center">
          <div className="space-y-4 w-full">
            <div className="flex flex-col items-center justify-center w-full">
              <label
                htmlFor="dropzone-file"
                className="flex flex-col items-center justify-center w-full h-64 border-dashed border-[0.5px] border-[#33363A] rounded-lg cursor-pointer"
              >
                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="w-8 h-8 mb-4 text-gray-500"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 16.5V9.75m0 0 3 3m-3-3-3 3M6.75 19.5a4.5 4.5 0 0 1-1.41-8.775 5.25 5.25 0 0 1 10.233-2.33 3 3 0 0 1 3.758 3.848A3.752 3.752 0 0 1 18 19.5H6.75Z"
                    />
                  </svg>
                  <p className="mb-2 text-sm text-gray-500">
                    <span className="font-semibold">Click to upload</span>
                  </p>
                  <p className="text-xs text-gray-500">JS only (MAX. 10mb)</p>
                </div>
                <input id="dropzone-file" type="file" className="hidden" onChange={handleFileChange} />
              </label>
            </div>
            <button
              type="submit"
              className="
              w-full
              py-2 px-4
              rounded-lg 
              bg-indigo-500 hover:bg-indigo-700 transition transform 
              font-medium text-white text-center"
              onClick={handleFileUpload}
            >
              Submit upload
            </button>
            <button
              type="button"
              className="
              py-2 px-4 
              w-full
              rounded-lg
              bg-[#292929] hover:bg-[#313131]
              font-bold text-gray-500"
              onClick={() => {
                setModalOpen(!modalOpen);
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>

      <div
        className="
        flex items-center justify-between space-x-4 
        mx-auto mt-4 p-4 px-4
        select-none w-full
        "
      >
        <div className="flex items-center space-x-4">
          <div
            className="
            flex-shrink-0 
            p-2
            cursor-pointer 
            rounded-full
            hover:bg-[#272727] hover:scale-[1.1] transition-all
            "
            onClick={() => navigate(-1)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-chevron-left"
            >
              <path d="M9 14 4 9l5-5" />
              <path d="M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5v0a5.5 5.5 0 0 1-5.5 5.5H11" />
            </svg>
          </div>
          <div className="flex-1 text-white font-semibold text-2xl"> Plugins List</div>
        </div>
        <div className="flex-shrink-0 cursor-pointer">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="stroke-white w-8 h-8 fill-none rounded-full p-2 bg-indigo-500 hover:bg-indigo-700 hover:scale-[1.1] transition-all"
            onClick={() => {
              toast.warning('Feature disabled', {
                description: 'We are updating this feature to a new version'
              });
            }}
          >
            <path d="M5 12h14" />
            <path d="M12 5v14" />
          </svg>
        </div>
      </div>

      <div
        className="
        m-3
        rounded-2xl
        h-[70vh]
        border-[0.5px] border-[#33363A]
        overflow-y-scroll scrollbar-thin
        text-gray-100
        "
      >
        {uploadedFiles.length === 0 ? (
          <div className="flex items-center justify-center h-full">
            <p className="text-lg font-semibold">No plugins uploaded yet</p>
          </div>
        ) : (
          uploadedFiles.map((file) => (
            <div
              className="
            flex flex-row justify-between items-center 
            p-4 m-2
            rounded-2xl
            cursor-pointer hover:bg-[#1a1a1a60] transition-all
          "
            >
              <div className="flex-shrink-0">
                <div className="flex items-center justify-center m-1 h-16 w-16 bg-[#1a1a1a] rounded-xl">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="fill-white w-8 h-8">
                    <path
                      fillRule="evenodd"
                      d="M14.447 3.026a.75.75 0 0 1 .527.921l-4.5 16.5a.75.75 0 0 1-1.448-.394l4.5-16.5a.75.75 0 0 1 .921-.527ZM16.72 6.22a.75.75 0 0 1 1.06 0l5.25 5.25a.75.75 0 0 1 0 1.06l-5.25 5.25a.75.75 0 1 1-1.06-1.06L21.44 12l-4.72-4.72a.75.75 0 0 1 0-1.06Zm-9.44 0a.75.75 0 0 1 0 1.06L2.56 12l4.72 4.72a.75.75 0 0 1-1.06 1.06L.97 12.53a.75.75 0 0 1 0-1.06l5.25-5.25a.75.75 0 0 1 1.06 0Z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-white text-lg truncate ml-2">{file}</p>
              </div>
              <div className="inline-flex items-center group">
                <div
                  className="flex items-center justify-center m-1 h-16 w-16 group-hover:scale-150 transition cursor-pointer "
                  onClick={() => handlePluginExecution(file)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="w-8 h-8 stroke-indigo-500 group-hover:fill-indigo-500 duration-150 text-transparent"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      <div className="fixed w-full bottom-0 right-0 text-center py-4 lg:px-4 select-none">
        <div
          className="p-2 bg-indigo-800 items-center text-indigo-100 leading-none rounded-full  inline-flex hover:scale-[1.1] transition cursor-pointer"
          onClick={handleDownload}
          role="alert"
        >
          <span className="flex rounded-full bg-indigo-500 uppercase px-2 py-1 text-xs font-bold mr-3">Example</span>
          <span className="font-semibold mr-2 text-left flex-auto">Download plugin example here</span>
          <svg className="fill-current opacity-75 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z" />
          </svg>
        </div>
      </div>
    </AdminLayout>
  );
}
